// custom code for view full ingredients modal //
const ingredientsModal = document.getElementById('ingredients-modal');
const ingredientsTrigger = document.getElementById('ingredients-trigger');
const ingredientsClose = document.getElementsByClassName('ingredients-modal-close')[0];
const body = document.body;

window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});

const closeDialog = () => {
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
  ingredientsModal.style.display = 'none';
};

const showDialog = () => {
  ingredientsModal.style.display = 'block';
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}`;
};

ingredientsTrigger.addEventListener('click', () => {
  showDialog();
});

ingredientsClose.addEventListener('click', () => {
  closeDialog();
});

window.addEventListener('click', (event) => {
  if (event.target == ingredientsModal) {
    closeDialog();
  }
});
